import { render, staticRenderFns } from "./InfoFields.vue?vue&type=template&id=04cc86d9&scoped=true"
import script from "./InfoFields.vue?vue&type=script&lang=js"
export * from "./InfoFields.vue?vue&type=script&lang=js"
import style0 from "./InfoFields.vue?vue&type=style&index=0&id=04cc86d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc86d9",
  null
  
)

export default component.exports